import { arrayBufferResponse } from "../Constant/common";
import {
  LISTOFCENTER,
  FILEUPLOAD,
  LISTOFSTATE,
  LISTOFDISTRICT,
  LISTOFCITY,
  LISTOFROLE,
  FILEDELETE,
  FILEDOWNLOAD,
  SUBSCRIPTIONLIST,
} from "./apiRoutes";
import { authData, multipartDataWithToken } from "./Service";

export const centerApi = async (data) => {
  const response = await authData.post(LISTOFCENTER, data);
  return response?.data;
};
export const fileUploadApi = async (data) => {
  const response = await multipartDataWithToken.post(FILEUPLOAD, data);
  return response?.data;
};
export const fileDeleteApi = async (data) => {
  const response = await authData.delete(FILEDELETE, { data: data });
  return response?.data;
};
export const listOfState = async (data) => {
  const response = await authData.post(LISTOFSTATE, data);
  return response?.data;
};
export const listOfDistrict = async (data) => {
  const response = await authData.post(LISTOFDISTRICT, data);
  return response?.data;
};
export const listOfCity = async (data) => {
  const response = await authData.post(LISTOFCITY, data);
  return response?.data;
};

export const listOfRoleApi = async (data) => {
  const response = await authData.post(`${LISTOFROLE}`, data);
  return response?.data;
};
export const fileDownloadApi = async (data) => {
  const response = await authData.post(`${FILEDOWNLOAD}`, data, arrayBufferResponse);
  return response?.data;
};

export const listOfSubscriptionApi = async () => {
  const response = await authData.get(SUBSCRIPTIONLIST);
  return response?.data;
};
